import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'excavation',
    title: 'Excavation',
    icon: 'ri-tools-line',
    desc: 'Residential and commercial foundation prep, drainage, utility trenching, pond construction, and more. From backyard projects to large-scale site excavation, we handle it all.',
    details: [
      'Foundation and site excavation',
      'Drainage correction and installation',
      'Utility trenching',
      'Pond construction and shaping',
      'Retaining wall prep',
    ],
    img: 'https://static.readdy.ai/image/461a3833cd00dd501e90f2080ae5acc6/8482cd284e0748429531f8100daf4137.png',
  },
  {
    id: 'grading',
    title: 'Grading',
    icon: 'ri-road-map-line',
    desc: 'We provide grading services for driveways, building pads, parking areas, and general property restoration. Finish grading, regrading, soil reconditioning, and gravel road and driveway repair.',
    details: [
      'Finish grading and regrading',
      'Driveway and access road repair',
      'Building pad preparation',
      'Parking area leveling',
      'Soil reconditioning and drainage correction',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/2d23aecd-16c9-4e0b-89ec-7b0832bedc2f_finish-grading.png?v=4ef17fd97658a42011c885aca039e840',
  },
  {
    id: 'property-management',
    title: 'Property Maintenance',
    icon: 'ri-home-gear-line',
    desc: 'We offer ongoing property maintenance services for landowners who want their property maintained and looking its best year-round. From routine lawn care and landscaping to general upkeep of larger rural properties, we handle the details so you don\'t have to.',
    details: ['Lawn mowing & maintenance', 'Landscaping & trimming', 'Seasonal property cleanup', 'Rural property upkeep', 'Long-term maintenance contracts'],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/cd9bb063-2ab7-4406-9585-aa5fe8caff4e_landscaping.png?v=e77d68a467e989e25f85a87c1717707b',
  },
  {
    id: 'forestry-mulching',
    title: 'Forestry Mulching',
    icon: 'ri-plant-line',
    desc: 'Forestry mulching is a low-impact clearing method that grinds standing trees, brush, and undergrowth into a natural mulch layer. No hauling, no burning, no exposed soil. It\'s the right approach when you want to clear selectively, maintain ground cover, or work in areas where full removal isn\'t necessary or practical.',
    details: [
      'Selective clearing without soil disruption',
      'Property line and fence row maintenance',
      'Right-of-way and utility corridor clearing',
      'Underbrush management',
      'Ideal for wildlife habitat improvement and land management',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/79743a84-e7ff-4c66-8875-46539e5d3986_kubota-mulching.png?v=722293d518fb1b16b8f2659bfc68a5f1',
  },
  {
    id: 'land-clearing',
    title: 'Land Clearing',
    icon: 'ri-scissors-cut-line',
    desc: 'We clear land for residential, commercial, and agricultural use. Single homesites, multi-acre tracts, overgrown pastures, neglected properties that haven\'t been touched in years. We remove trees, stumps, brush, and debris and leave you with a clean, usable site ready for construction, grading, or whatever comes next.',
    details: [
      'Full tree and brush removal',
      'Overgrown property and pasture reclamation',
      'Fence line and boundary restoration',
      'Stump removal and root raking',
      'Debris hauling and site cleanup',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/3d85cbc7-a4d0-42ee-ae56-c66e3e33d523_clearing.png?v=5a193f9b7a4ad603c4739cc652c9557e',
  },
  {
    id: 'site-development',
    title: 'Site Development',
    icon: 'ri-building-line',
    desc: 'We prepare properties for construction from the ground up. Clearing, grading, drainage, access roads, and utility trenching. We work directly with homeowners and builders to get the site ready before construction begins.',
    details: [
      'Clearing and grading for building sites',
      'Drainage grading and drainage system installation',
      'Access road construction with base material and gravel',
      'Culvert installation',
      'Utility trenching',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/9b0cd3fa-016a-4238-b7bb-db1e268708cc_site-prep.png?v=156015bad5f0caca2e1e7880bd495762',
  },
  {
    id: 'demolition',
    title: 'Demolition',
    icon: 'ri-hammer-line',
    desc: 'Residential and commercial structures, foundations, concrete, full site cleanup. We handle the complete job from teardown to clean ground.',
    details: [
      'Homes, barns, and outbuilding removal',
      'Foundation and slab breakout',
      'Concrete removal and disposal',
      'Complete site cleanup and restoration',
      'Commercial demolition available',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/dc00ffd5-0e44-456c-9fdc-611d6f90b503_demolition.png?v=46e9ba27bf5f9cafa3d060dc030d074b',
  },
  {
    id: 'food-plot-development',
    title: 'Food Plot Development',
    icon: 'ri-leaf-line',
    desc: 'We build food plots from start to finish; clearing, grading, soil prep, and planting. Whether it\'s a single plot or a full property layout, we handle the land work and the strategy behind it. We also develop access roads, trail systems, and habitat features designed to influence deer movement and bedding patterns across your property.',
    details: [
      'Turnkey food plot installation from clearing through seeding',
      'Grading and drainage for long-term plot health',
      'Access roads and trail networks for low-impact entry',
      'Habitat management to direct deer travel and bedding',
      'Properties of all sizes, from small plots to full lease setups',
    ],
    img: 'https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/eb0e09b3-8cb8-49ce-b037-bf9cf47e498a_food-plot-1.png?v=0cd24f6e2f27e5ed7340e7b057c16213',
  },
];

export default function Services() {
  return (
    <div className="min-h-screen bg-brand-black font-body">
      <Navbar />

      {/* Page Header */}
      <section className="relative w-full pt-32 pb-20 px-6 lg:px-12 bg-brand-charcoal overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/faa8c07988d5015cb63cedadb362b430.jpg"
            alt="Land management services"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto">
          <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">What We Offer</p>
          <h1 className="font-heading font-800 text-white text-6xl md:text-7xl tracking-widest uppercase">
            Our Services
          </h1>
          <div className="w-12 h-0.5 bg-brand-green-accent mt-5" />
        </div>
      </section>

      {/* Services */}
      <main className="w-full px-6 lg:px-12 py-20">
        <div className="w-full max-w-7xl mx-auto flex flex-col gap-20">
          {services.map((svc, idx) => (
            <div
              key={svc.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? 'lg:flex lg:flex-row-reverse' : ''}`}
            >
              {/* Image */}
              <div className="relative h-72 lg:h-80 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-black/40 to-transparent" />
              </div>
              {/* Text */}
              <div className={`${idx % 2 === 1 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-green/20 border border-brand-green-mid rounded-sm">
                    <i className={`${svc.icon} text-brand-green-accent text-xl`} />
                  </div>
                  <h2 className="font-heading font-800 text-white text-3xl md:text-4xl tracking-wider uppercase">
                    {svc.title}
                  </h2>
                </div>
                <div className="w-8 h-0.5 bg-brand-green-accent mb-5" />
                <p className="font-body text-gray-400 text-sm leading-relaxed mb-6">
                  {svc.desc}
                </p>
                <ul className="flex flex-col gap-2">
                  {svc.details.map((d) => (
                    <li key={d} className="flex items-center gap-3">
                      <div className="w-4 h-4 flex items-center justify-center shrink-0">
                        <i className="ri-arrow-right-s-line text-brand-green-accent text-sm" />
                      </div>
                      <span className="font-body text-sm text-gray-300">{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* CTA */}
      <section className="w-full bg-brand-green py-16 px-6 lg:px-12">
        <div className="w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-heading font-800 text-white text-3xl tracking-widest uppercase">Ready to Discuss Your Project?</h3>
            <p className="font-body text-green-200 text-sm mt-2">One call covers everything. We can help.</p>
          </div>
          <Link
            to="/contact"
            className="shrink-0 px-8 py-4 bg-white hover:bg-gray-100 font-heading font-700 text-brand-green text-base tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
          >
            Get a Free Quote
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
